// Which month the Costs screen is describing, and whether it is this one.
//
// The screen shows the newest month the cost feed has written, because that is the only month
// there is data for. When the feed has not written since the month turned, that month is over,
// so "this month" and a projection to the end of it are both claims about a month that is not
// the current one. This says so, once, in a form the screen can act on.

/** `YYYY-MM` for a date, in UTC like the cost records' own period. */
export function monthOf(date) {
  return new Date(date).toISOString().slice(0, 7);
}

/** True when the month shown is before the current one, so nothing on it is "this month". */
export function isPastMonth(period, now = new Date()) {
  return Boolean(period) && /^\d{4}-\d{2}$/.test(period) && period < monthOf(now);
}

/** What to call the month shown: "this month" only when it is. */
export function monthWord(period, now = new Date()) {
  return isPastMonth(period, now) ? period : "this month";
}
